import { render, staticRenderFns } from "./kehittamistoimenpiteet-card.vue?vue&type=template&id=23a7d2b6&"
import script from "./kehittamistoimenpiteet-card.vue?vue&type=script&lang=ts&"
export * from "./kehittamistoimenpiteet-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports